import React, { useState, useRef, useEffect } from "react";
import Table from "../../extra/OrderTable";
import {
  getHashTags,
  updateOrderHashtags,
} from "../../store/shorts/shorts.action";
import { useDispatch, useSelector } from "react-redux";

const OrderTag = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const { featureHashtags } = useSelector((state) => state.shorts);
  console.log(featureHashtags);
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getHashTags(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    if (featureHashtags) {
      setData(featureHashtags);
    }
  }, [featureHashtags]);

  const dragStart = (e, index) => {
    dragItem.current = index;
  };

  const dragEnter = (e, index) => {
    dragOverItem.current = index;
  };

  const drop = () => {
    const copyListItems = [...data];

    if (dragItem.current !== null && dragOverItem.current !== null) {
      const draggedItem = copyListItems[dragItem.current];

      copyListItems.splice(dragItem.current, 1);
      copyListItems.splice(dragOverItem.current, 0, draggedItem);

      setData(copyListItems);
    }
    dispatch(updateOrderHashtags(copyListItems));
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const videoMapData = [
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "HashTag",
      body: "uniqueId",
      Cell: ({ row }) => <span className="cursorPointer">{row}</span>,
    },
  ];

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "4px",
                marginTop: "5px",
              }}
            >
              Order Tags
            </h5>
          </div>
        </div>
        <Table
          data={data}
          mapData={videoMapData}
          serverPerPage={size}
          serverPage={page}
          type={"server"}
          dragStart={dragStart}
          dragEnter={dragEnter}
          drop={drop}
        />
      </div>
    </div>
  );
};

export default OrderTag;
